exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".control-hint-bubble {\n  position: absolute;\n  display: none;\n  z-index: 100;\n  min-width: 200px;\n  max-width: 300px;\n  background-color: white;\n  border: 1px solid rgba(34, 34, 34, 0.54);\n  border-radius: 5px;\n  padding: 10px;\n  text-align: left; }\n  .control-hint-bubble.top {\n    bottom: 22px;\n    right: 0px; }\n  .control-hint-bubble.bottom {\n    top: 22px;\n    right: 0px; }\n  .control-hint-bubble.show {\n    display: block; }\n\ni {\n  padding: 0 10px;\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?{"includePaths":["/root/src/ui","/root/src/ui/node_modules"]}!./~/import-glob-loader!./app/common/forms/control-hint.component.sass
// module id = 1095
// module chunks = 4